
import { Link }from "react-router-dom";
import "../../Styles/Loginpage/Parentlogin.css";



export default function ParentSignup() {
  


  return (
    <div className="parent-login-container my-4">
      <div className="parent-login-card">
        <div className="parent-login-content">
        <img src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg" alt="YellowCalf Logo" className="parent-login-logo" />

        <h4 className="parent-login-heading">Parent Signup</h4>

        <hr className="parent-divider" />

        <form>


          <div className="form-group mb-2 position-relative">
           <span className="input-icon">
            <i className="fa fa-university"></i>
          </span>
          <label htmlFor="schoolname" className="text-starting form-label">School Name</label>
          <select
            className="form-control">
            <option value="">Select School</option>
            <option value="School A">Grand College Melkart</option>
            <option value="School B">Niceways College</option>
             <option value="School c">AAB College</option>
          </select>
          </div>

          <div className="d-flex gap-3 mb-3 small">
            <Link to="/parentregistration" className="text-primary">
              <i className="bi bi-phone"></i> Register Parent Without School
            </Link>
           
          </div>

          <div className="d-flex justify-content-between align-item-conter">
            <Link to="/login" type="submit" className="btn custom-btn">
             <i className="fa fa-arrow-left"></i>   Back to Login 
            </Link>
            <Link to="/parentregistration" type="submit" className="btn custom-btn">
              Continue <i className="fa fa-arrow-right"></i>
            </Link>
          </div>
        </form>

        <p className="text-center mt-3 mb-0 small">2025 © YellowCafl</p>
      </div>
      </div>
    </div>
  );
}
